import React from 'react';
import { Text } from '@fluentui/react';

const SectionTitle = ({ children }: { children: React.ReactNode }): JSX.Element => (
    <Text variant="xLarge" styles={{ root: { marginTop: 30, marginBottom: 10 } }}>
        {children}
    </Text>
);

export default SectionTitle;
